'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useState } from 'react';

import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/AlertDialog';
import { Button } from '@/components/ui/Button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/Tabs';
import { useTabContext } from '../context/TabContext';
import Link from 'next/link';

export default function NavigationSystem() {
  const { selectedTab, setSelectedTab } = useTabContext();
  const [showDialog, setShowDialog] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  // Handle tab changes
  const handleTabChange = (value) => {
    if (value === 'adviser' && !pathname.startsWith('/professionals')) {
      setShowDialog(true);
    } else if (value === 'adviser') {
      router.push('/professionals');
      setSelectedTab(value);
    } else {
      router.push('/');
      setSelectedTab(value);
    }
  };
  // Handle confirmation
  const handleConfirm = () => {
    router.push('/professionals');
    setSelectedTab('adviser');
    setShowDialog(false);
  };

  // TabContext now handles tab determination based on pathname automatically

  return (
    <>
      <div className={`fixed left-0 top-0 w-full ${selectedTab === 'adviser' ? 'bg-[#212C55]' : 'bg-[#682045]'}`}
      >
        <div className="container flex justify-between h-[39px]">
          <Tabs value={selectedTab} onValueChange={handleTabChange}>
            <TabsList className="flex border-gray-200">
              <TabsTrigger
                value="customer"
                className={`flex h-[39px] items-center space-x-1 rounded-none font-medium ${
                  selectedTab === 'customer'
                    ? 'bg-white text-[#682045]'
                    : 'bg-[#101733] text-white hover:text-white'
                }`}
              >
                <Link href="/">Customer</Link>
              </TabsTrigger>
              <TabsTrigger
                value="adviser"
                className={`flex h-[39px] items-center space-x-1 rounded-none font-medium ${
                  selectedTab === 'adviser'
                    ? 'bg-white text-[#212C55]'
                    : 'bg-[#360525] text-white hover:text-white'
                }`}
              >
                <Link href="/professionals">Adviser</Link>
              </TabsTrigger>
            </TabsList>
          </Tabs>
          <Tabs value={selectedTab}>
            <TabsList className="flex border-gray-200">
              <TabsTrigger
                value="adviser"
                className={`flex h-[39px] items-center space-x-1 rounded-none font-medium ${
                  selectedTab === 'customer'
                    ? 'bg-[#360525] text-white hover:text-white'
                    : 'bg-[#101733] text-white hover:text-white'
                }`}
              >
                <Link href={`${selectedTab === 'customer' ? '/contact-us' : '/professionals/contact-us'}`}>Contact Us</Link>
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>

      <AlertDialog open={showDialog} onOpenChange={setShowDialog}>
        <AlertDialogContent className="max-w-[38rem] bg-white px-10 py-16">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-center text-[#000] font-normal text-l ">
              You are about to visit our Pure Professionals website, that is intended for use by financial intermediaries only.
            </AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogFooter className="">
            <div className="flex flex-col items-center justify-center w-full space-y-5 sm:space-y-6 md:space-y-8 lg:space-y-10">
              <AlertDialogCancel
                className="w-full h-[6rem] sm:h-[7rem] md:h-[7rem] bg-[#4f1030] rounded-xl text-[#F3F4F8] hover:bg-[#4f1030]/90 font-semibold text-xl sm:text-2xl md:text-2xl  flex flex-col justify-center items-center p-4 sm:p-6 md:p-8 lg:p-6 gap-1 sm:gap-2 md:gap-3 self-stretch"
                onClick={() => router.push('/')}
              >
                Customer
                <span className="text-sm sm:text-base md:text-l font-normal sm:font-medium md:font-semibold">Please take me back to Pure Retirement</span>
              </AlertDialogCancel>
              <Button
                className="w-full h-[6rem] sm:h-[7rem] md:h-[7rem] rounded-xl bg-[#212C55] text-[#F3F4F8] hover:bg-[#212C55]/90 font-semibold text-xl sm:text-2xl md:text-2xl  flex flex-col justify-center items-center p-4 sm:p-6 md:p-8 lg:p-6 gap-1 sm:gap-2 md:gap-3 self-stretch"
                onClick={handleConfirm}
              >
                Financial intermediaries
                <span className="text-sm sm:text-base md:text-l font-normal sm:font-medium md:font-semibold">Please continue to Pure Professionals</span>
              </Button>
            </div>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
